<!-- Section: about card listing the application technical versions -->
<div class="about-card flex flex-col p-8 rounded-lg">
  <h1 class="mt-0 mb-6">About</h1>

  <!-- Version of the project, read from package.json -->
  <div class="version-row flex justify-between py-3">
    <span >App version</span>
    <span class="value">{{ appVersion }}</span>
  </div>

  <!-- Version of the Angular framework the app is built with -->
  <div class="version-row flex justify-between py-3">
    <span >Angular version</span>
    <span class="value">{{ angularVersion }}</span>
  </div>
</div>
